<template>
    <div>
        <div class="tit-head">
            <div>判断题</div>
            <!-- <div class="stem" v-html="info.title"></div> -->
            <mavonEditor 
                :boxShadow="false" 
                styleEditor="min-height: 20px;width: auto;" 
                :content="info.title" 
                :subfield="false" 
                :toolbarsFlag="false" 
                previewBackground="#fff"
                defaultOpen="preview" 
            />
        </div>
        
        <div class="jugle">
            <Radio-group v-model="info.yourAnswer" vertical @on-change="change">
                <Radio label="A">
                    <span>A、正确</span>
                </Radio>
                <Radio label="B">
                    <span>B、错误</span>
                </Radio>
                </Radio-group>
        </div>
    </div>
</template>
<script>
import mavonEditor from './mavonEditor.vue'
export default {
    components:{ mavonEditor },
    props:{
        info:{
            type:Object,
            default:null
        },
        yourAnswer:{
            type: String,
            default: null
        }
    },
    data(){
        return{
            jugleAnswer:''
        }
    },
    created(){
    },
    methods:{
        change(){
            this.$emit('childQuestionFn', {answer:this.info.yourAnswer, questionId: this.info.id});
        }
    }
}
</script>
<style lang="less" scoped>
.stem{
    /deep/ img{
        max-width: 100%;
    }
    /deep/ p{
        font-size: 16px;
        color: #555;
        font-weight: 700;
    }
}
.tit-head{
    flex-wrap: wrap;
    display: inline-flex;
    width: 100%;
    div:first-child{
        display: inline-flex;
        align-items: center;
        color: #555;
        height: 26px;
        line-height: 26px;
        background-color: #18A0FB;
        color: #fff;
        padding: 0 10px;
        border-radius: 13px 13px 0 13px;
        margin-right: 15px;
        min-width: 62px;
    }
    .stem{
        width: 80%;
        /deep/ img{
            max-width: 100%;
        }
        /deep/ p{
            font-size: 16px;
            font-weight: 700;
            color: #555;
        }
    }
}
.jugle {
    margin-left: 60px;
    .ivu-radio-wrapper {
    display: flex;
    align-items: center;
    margin: 10px 0;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/practise/components/questionJugle.vue